export const API_CASES_EXTRACT_DOWNLOAD = 'API_CASES_EXTRACT_DOWNLOAD'
export const API_CASES_EXTRACT_DOWNLOAD_RESPONSE = 'API_CASES_EXTRACT_DOWNLOAD_RESPONSE'

export const apiCasesExtractDownload = (data) => {
    return {
        type: API_CASES_EXTRACT_DOWNLOAD,
        data
    }
}

export const apiCasesExtractDownloadResponse = (data) => {
    return {
        type : API_CASES_EXTRACT_DOWNLOAD_RESPONSE,
        data
    }
}